import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { getPayments, getSelectedPaymentType, isVehicleLoading, isVehicleUpdating } from "src/store/selectors/vehicles";
import CalculatedPaymentInline from "./CalculatedPaymentInline";
import { getAccountPhoneNumber } from "src/store/selectors/account";

// CAN ONLY BE USED PAST CONTINUE DEAL SINCE THIS REQUIRES `currentDeal.vin`
function mapStateToProps(state: ApplicationStore) {
    const { account, currentDeal } = state;
    return {
        account,
        isPaymentsLoading: isVehicleLoading(state, currentDeal.vin!) || isVehicleUpdating(state, currentDeal.vin!),
        payments: getPayments(state, currentDeal.vin!),
        selectedPaymentIndex: getSelectedPaymentType(state, currentDeal.vin!),
        vin: currentDeal.vin!,
        phoneNumber: getAccountPhoneNumber(state),
    };
}

export default connect(mapStateToProps)(CalculatedPaymentInline);
